import { currentVehicleAtom } from '@core/Atoms/Vehicle/CurrentVehicle.atom';
import { flagsAtom } from '@growthBookExperimentation/Atoms/Flags.atom';
import { atom } from 'jotai';

import { leadCtasConfig } from 'Components/Pdp/LeadCTAs/LeadCtaConfig';

export const shouldRequestVideoAtom = atom(get => {
  const vehicle = get(currentVehicleAtom);
  const flags = get(flagsAtom);

  if (!vehicle) return false;

  const shouldRequestVideo = leadCtasConfig['request-video'].isActive({
    flags,
    vehicle,
    isEcom: !!vehicle.ecom?.isEcom,
  });

  return shouldRequestVideo;
});
